import { QuestionFieldFragment } from "@/generated/graphql";
import HotspotTextChoiceResponseForm from "./hotspot-text-choice/hotspot-text-choice-response-form";
import HotspotPositionObjectResponseForm from "./hotspot-position-object/hotspot-position-object-response-form";

interface HotspotResponseFormProps {
  answerBlockId: string;
  questionFields: QuestionFieldFragment[];
  isReadonly?: boolean;
  isPositionObjectHotspot: boolean;
}

export const HotspotResponseForm: React.FC<HotspotResponseFormProps> = ({
  answerBlockId,
  questionFields,
  isReadonly = false,
  isPositionObjectHotspot,
}) => {
  return isPositionObjectHotspot ? (
    <HotspotPositionObjectResponseForm
      answerBlockId={answerBlockId}
      questionFields={questionFields}
      isReadonly={isReadonly}
    />
  ) : (
    <HotspotTextChoiceResponseForm
      answerBlockId={answerBlockId}
      questionFields={questionFields}
      isReadonly={isReadonly}
    />
  );
};

export default HotspotResponseForm;
